(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dovelka-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!window.dovelkaSizeChartReadyV2) {
    window.dovelkaSizeChartReadyV2 = true;

    const setDovelkaSizeUnitV2 = (dialog, unit) => {
      if (!dialog) return;
      const activeUnit = unit === 'cm' ? 'cm' : 'in';
      dialog.setAttribute('data-active-unit', activeUnit);

      dialog.querySelectorAll('[data-dovelka-unit]').forEach((button) => {
        button.setAttribute('aria-pressed', button.getAttribute('data-dovelka-unit') === activeUnit ? 'true' : 'false');
      });

      dialog.querySelectorAll('[data-dovelka-unit-value]').forEach((value) => {
        const isActive = value.getAttribute('data-dovelka-unit-value') === activeUnit;
        value.hidden = !isActive;
        value.style.display = isActive ? '' : 'none';
      });
    };

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const openButton = target.closest('[data-dovelka-size-chart-open]');
      if (openButton) {
        event.preventDefault();
        const picker = openButton.closest('.dovelka-variant-picker');
        const dialog = picker?.querySelector('.dovelka-size-chart');
        if (dialog) {
          setDovelkaSizeUnitV2(dialog, dialog.getAttribute('data-default-unit') || 'in');
          dialog.showModal();
        }
        return;
      }

      const closeButton = target.closest('[data-dovelka-size-chart-close]');
      if (closeButton) {
        event.preventDefault();
        closeButton.closest('dialog')?.close();
        return;
      }

      const unitButton = target.closest('[data-dovelka-unit]');
      if (unitButton) {
        event.preventDefault();
        const dialog = unitButton.closest('.dovelka-size-chart');
        setDovelkaSizeUnitV2(dialog, unitButton.getAttribute('data-dovelka-unit'));
        return;
      }

      const toggleButton = target.closest('[data-dovelka-unit-toggle]');
      if (toggleButton) {
        event.preventDefault();
        const dialog = toggleButton.closest('.dovelka-size-chart');
        const nextUnit = dialog?.getAttribute('data-active-unit') === 'cm' ? 'in' : 'cm';
        setDovelkaSizeUnitV2(dialog, nextUnit);
        return;
      }

      if (target.matches('.dovelka-size-chart')) {
        target.close();
      }
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
